<template>
    <div>
        <div class="p-3 variable-content">
            <div class="row">
                <div v-for="i in 4" class="col-3 px-1">
                    <input
                        :disabled="i > 1 && typeof scores[i - 2] === 'undefined'"
                        class="form-control cme p-1"
                        v-model.number="scores[i - 1]"
                        type="number"
                        value=""
                        :id="`score-${i - 1}`"
                    />
                </div>
            </div>

            <div class="row">
                <div v-for="i in 4" class="col-3 my-2 px-1">
                    <input
                        :disabled="typeof scores[i - 1 + 3] === 'undefined'"
                        class="form-control cme p-1"
                        v-model.number="scores[i - 1 + 4]"
                        type="number"
                        value=""
                        :id="`score-${i - 1 + 4}`"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-3">
                    <span class="text-muted summary">Score Average</span>
                </div>
                <div class="col-3 text-right" style="border-left: solid 2px #8f8f8f;">
                    <span class="cme">{{ averageScore }}</span>
                </div>
                <div class="col-3">
                    <span class="text-muted summary">Best Score</span>
                </div>
                <div class="col-3 text-right" style="border-left: solid 2px #8f8f8f;">
                    <span class="cme">{{ bestScore }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Prompt from "../../ui/PromptIcon";

export default {
    name: "Cme",
    props: ["goal", "date", "customization", "flagData", "notesData"],
    components: { Prompt },
    data() {
        return {
            scores: [],
        };
    },
    computed: {
        averageScore() {
            let notEmpty = this.scores.filter(s => typeof s !== "undefined");
            let len = notEmpty.length;
            if (len === 0) {
                return 0;
            }
            let sum = notEmpty.reduce((a, b) => a + b);
            return Math.round(sum / len);
        },

        bestScore() {
            let notEmpty = this.scores.filter(s => typeof s !== "undefined");
            let len = notEmpty.length;
            if (len) {
                return Math.max.apply(null, notEmpty);
            }
        },
    },
    created() {},
    methods: {
        saveTrackerData() {
            let success = 0;
            if (this.goal.parameters.evaluate === "average") {
                success = this.averageScore;
            }
            if (this.goal.parameters.evaluate === "max") {
                success = this.bestScore;
            }
            const data = {
                session_at: this.date
                    ? this.moment(this.date).format("YYYY-MM-DD HH:mm:ss")
                    : this.moment().format("YYYY-MM-DD HH:mm:ss"),
                data: {
                    type: "cme",
                    success: success,
                    scores: this.scores.filter(s => typeof s !== "undefined"),
                },
            };
            axios
                .post(`/api/patients/${this.goal.patient.id}/goals/${this.goal.id}/trackers`, data)
                .then(r => {
                    this.reportResult(true);
                })
                .catch(error => {
                    this.$emit("save-draft", { error, data });
                    this.reportResult(false);
                    this.$swal({
                        title: "Error!",
                        text: "An error occurred while saving.",
                        type: "error",
                        confirmButtonText: "Close",
                        confirmButtonColor: "#d64571",
                    });
                    console.error(error);
                });
        },

        reportResult(success) {
            this.$emit("saved", success);
            if (success) {
                this.$emit(
                    "close-tracker",
                    this.goal.title +
                        ": " +
                        `Average ${this.averageScore}, highest ${this.bestScore}` +
                        " - " +
                        this.notesData
                );
            }
        },
    },
};
</script>

<style scoped lang="scss">
.cme {
    font-family: "Roboto Condensed", sans-serif;
    font-size: 3rem;
    line-height: 3rem;
    text-align: center;
}

.summary {
    line-height: 1;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="number"] {
    -moz-appearance: textfield;
}
</style>
